module.exports = {"title":"Некоторые женятся, а некоторые так","description":"В прокат выходит французская комедия «Праздничный переполох» - честный взгляд на превратности брака по-европейски.","image":"https://wedding.afisha.ru/img/share.jpg","url":"https://wedding.afisha.ru/","fbappid":2246741098886286,"trackingID":"UA-105301080-31","clientTrackingID":"UA-88014128-22","top100":4519990,"clientTop100":0,"yaMetrika":41254644}


//////////////////
// WEBPACK FOOTER
// ./js/meta.json
// module id = 481
// module chunks = 0